import { render } from "./top-traders.vue?vue&type=template&id=dd876528"
import script from "./top-traders.vue?vue&type=script&lang=js"
export * from "./top-traders.vue?vue&type=script&lang=js"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__